import VulnerabilitiesBlock from './VulnerabilitiesBlock';

export default VulnerabilitiesBlock;
